<template>
  <tr>
    <td class="text-center">
      <span class="form-control form-control-plaintext">{{rowIndex + 1}}</span>
    </td>
    <td class="form-group">
      <select2
        :css-style="'width: 100%;'"
        :css-class="'form-control required'"
        :id="'apUser' + _uid"
        :name="'apUser' + _uid"
        :select2-options="apUserOptions"
        @selectChange="onUserChange"
        v-model="apUser"
        ref="apUser"
        data-msg-required="กรุณาเลือกพนักงาน"
      ></select2>
      <span class="form-text"></span>
    </td>
    <td class="form-group">
      <select2
        :css-style="'width: 100%;'"
        :css-class="'form-control required'"
        :id="'apLevel' + _uid"
        :name="'apLevel' + _uid"
        :select2-options="apLevelOptions"
        @selectChange="onLevelChange"
        v-model="apLevel"
        ref="apLevel"
        data-msg-required="กรุณาเลือกลำดับอนุมัติ"
      ></select2>
      <span class="form-text"></span>
    </td>
    <td class="form-group">
      <select2
        :css-style="'width: 100%;'"
        :css-class="'form-control required'"
        :id="'apEditId' + _uid"
        :name="'apEdit' + _uid"
        :select2-options="apEditOptions"
        @selectChange="onEditChange"
        v-model="apEdit"
        ref="apEdit"
        data-msg-required="กรุณาเลือกเลือกสิทธิ์การแก้ไข"
      ></select2>
      <span class="form-text"></span>
    </td>
    <td class="form-group">
      <select2
        :css-style="'width: 100%;'"
        :css-class="'form-control required'"
        :id="'apApproveRow' + _uid"
        :name="'apApproveRow' + _uid"
        :select2-options="apApproveOptions"
        @selectChange="onApproveChange"
        v-model="apApproveRow"
        ref="apApprove"
        data-msg-required="กรุณาเลือกสิทธิ์การอนุมัติ"
      ></select2>
      <span class="form-text"></span>
    </td>
    <td class="form-group">
      <center>
        <a
          href="#"
          @click.prevent="detail"
          title="รายละเอียด"
          class="btn btn-sm btn-clean btn-icon btn-icon-md"
        >
          <i class="text-info far fa-file-alt"></i>
        </a>
        <button
          type="button"
          class="btn btn-outline-hover-danger btn-elevate btn-circle btn-icon"
          @click.prevent="onRemoveAPItemClick"
        >
          <i class="text-danger la la-trash"></i>
        </button>
      </center>
    </td>
  </tr>
</template>
<script>
import select2 from "../../../Shared/Select2";
import router from "../../../router";

export default {
  components: {
    select2
  },
  props: {
    isEditable: {
      type: Boolean,
      default: true
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    rowIndex: Number,
    item: {
      type: Object,
      required: true
    }
  },
  data: function() {
    var self = this;

    return {
      apUser: self.item.apUserRow,
      apLevel: self.item.apLevelRow,
      apEdit: self.item.apEditRow,
      apApproveRow: self.item.apApproveRow,
      apUserOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Users/Select2User",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      apLevelOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        minimumResultsForSearch: -1,
        ajax: {
          url: "/Api/Variables/Options",
          data: function(params) {
            var query = {
              search: "APPROVE_LEVEL",
              page: params.page || 1
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      apEditOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        minimumResultsForSearch: -1,
        data: [
          { id: true, text: "มี" },
          { id: false, text: "ไม่มี" }
        ]
      },
      apApproveOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        minimumResultsForSearch: -1,
        ajax: {
          url: "/Api/Variables/Options",
          data: function(params) {
            var query = {
              search: "APPROVE_ROLE",
              page: params.page || 1
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },
  methods: {
    onUserChange: function(id, text, data, ref) {
      this.item.apUserRow = this.apUser;
      this.item.selectedUserRow = {
        id: data[0].id,
        text: data[0].text
      };
    },
    onLevelChange: function(id, text, data, ref) {
      var self = this;
      var $id = "#apEditId" + self._uid;
      if (text == "APPROVE_LEVEL_2") {
        $($id)
          .val("true")
          .trigger("change");
      } else {
        $($id)
          .val("false")
          .trigger("change");
      }
      this.item.apEditRow = this.apEdit;
      this.item.apLevelRow = this.apLevel;
      this.item.selectedLevelRow = {
        id: data[0].id,
        text: data[0].text
      };
    },
    onEditChange: function(id, text, data, ref) {
      this.item.apEditRow = this.apEdit;
      this.item.selectedEditRow = {
        id: data[0].id,
        text: data[0].text
      };
    },
    onApproveChange: function(id, text, data, ref) {
      this.item.apApproveRow = this.apApproveRow;
      this.item.selectedApproveRow = {
        id: data[0].id,
        text: data[0].text
      };
    },
    onRemoveAPItemClick(e) {
      var self = this;
      self.$emit("removeItem", self.rowIndex, self.item);
    },
    detail() {
      var self = this;
      console.log(self.apUser);
      if (self.apUser != null)
        if (self.$parent.edit)
          router.push({
            path: `/Master/Approver/Edit/${self.$parent.uaApproveGroupID}/User/${self.apUser}`
          });
        else
          router.push({
            path: `/Master/Approver/Add/User/${self.apUser}`
          });
      else Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกพนักงาน", "error");
    }
  }
};
</script>
<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// App/Components/Master/Approver/ApproverItemRow.vue